module.exports = __webpack_public_path__ + "img/thumbnail_WildBoar_f_leucistic.793cf4fc.png";